import { translateText } from "../../utils/translation";
import Datepicker from "react-tailwindcss-datepicker";
import Dropdown from "./Dropdown";
import getDatepickerLocalisation from "../../utils/localisation";

interface DatetimeSelectorProps {
  label: string;
  showLabel?: boolean;
  dateState: { startDate: any; endDate: any };
  dateHandler: any;
  timeState: { hour: number; minute: number };
  timeHandler: any;
  language: string;
}

export default function DatetimeSelector({
  label,
  showLabel,
  dateState,
  dateHandler,
  timeState,
  timeHandler,
  language,
}: DatetimeSelectorProps) {
  const hours = Array.from({ length: 24 }, (x, i) => i);
  const minutes = Array.from({ length: 60 }, (x, i) => i);

  return (
    <div>
      {/* Label */}
      {showLabel && (
        <label
          className={`mb-3 block text-left text-sm font-medium text-black`}
        >
          {label}
        </label>
      )}

      <div className="grid grid-cols-4 gap-x-2">
        {/* Date picker */}
        <div className="date-picker-wrapper w-full col-span-2">
          <Datepicker
            i18n={getDatepickerLocalisation(language)}
            asSingle={true}
            startFrom={new Date()}
            minDate={new Date()}
            value={dateState}
            onChange={dateHandler}
          />
        </div>

        {/* Hour picker */}
        <Dropdown
          id="hour"
          className="col-span-full"
          label=""
          showLabel={false}
          required={true}
          state={timeState}
          stateName="hour"
          onChange={timeHandler}
          defaultValue={timeState.hour}
        >
          <option value="">{translateText("hour", language)}</option>
          {hours.map((hour) => (
            <option key={`hour-${hour}`} value={hour}>
              {hour < 10 ? `0${hour}` : hour}
            </option>
          ))}
        </Dropdown>

        {/* Minute picker */}
        <Dropdown
          id="minute"
          className="col-span-full"
          label=""
          showLabel={false}
          required={true}
          state={timeState}
          stateName="minute"
          onChange={timeHandler}
          defaultValue={timeState.minute}
        >
          <option value="">{translateText("minute", language)}</option>
          {minutes.map((minute) => (
            <option key={`minute-${minute}`} value={minute}>
              {minute < 10 ? `0${minute}` : minute}
            </option>
          ))}
        </Dropdown>
      </div>
    </div>
  );
}
